<template>
  <v-container class="blank" />
</template>

<script>
export default {
  name: 'Blank',
};
</script>
